<template>
  <div class="main" id="imprimir" sandbox="allow-forms">
    <form>
      <div class="row position-relative mt-5 d-none d-sm-none d-md-block" style="z-index:999">
        <div class="col-10 row offset-1 top40">
          <div class="col-5">
            <select name="origen"
                    @change="changeStart"
                    class="bg-menu form-control border-0 font-weight-bold text-verde radius-25 text-center w-20"
                    v-model="start">
              <option value="0" class="text-verde" disabled="disabled">ORIGEN</option>
              <option v-for="node in validStartNodes" :value="node.value">{{ node.poste }}: {{ node.text }}</option>
            </select>
          </div>
          <div class="col-2 text-center rounded-circle">
            <img class="w40" src="assets/img/flecha.svg"/>
          </div>
          <div class="col-5">

            <select name="destino"
                    @change="changeEnd"
                    class="bg-menu form-control border-0 font-weight-bold text-verde radius-25 text-center w-20"
                    v-model="end">
              <option value="0" class="text-verde" disabled="disabled">DESTINO</option>
              <option v-for="node in validEndNodes" :value="node.value">{{ node.poste }}: {{ node.text }}</option>
            </select>
          </div>
        </div>
      </div>
      <!--MOVIL-->
      <div class="row d-block d-sm-none">
        <div class="col-12">
          <div class="col-12">
            <label class="font-weight-bold text-verde text-center">ORIGEN
              <select name="origen"
                      @change="changeStart"
                      class="form-control border-0 font-weight-bold text-verde radius-25"
                      v-model="start">
                <option value="0" class="text-verde" disabled="disabled">ORIGEN</option>
                <option v-for="node in validStartNodes" :value="node.value">{{ node.value }}: {{ node.text }}</option>
              </select>
            </label>
          </div>
          <div class="clearfix"></div>
          <div class="col-12">
            <label class="font-weight-bold text-verde text-center">DESTINO
              <select name="destino"
                      @change="changeEnd"
                      class="form-control border-0 font-weight-bold text-verde radius-25"
                      v-model="end">
                <option value="0" class="text-verde" disabled="disabled">DESTINO</option>
                <option v-for="node in validEndNodes" :value="node.value">{{ node.value }}: {{ node.text }}</option>
              </select>
            </label>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <br>
      <!--MAPA-->
      <div class="row" id="mapview">
        <div class="image-16-9 rounded position-relative radius-20 " id="mapid">
        </div>
      </div>
    </form>
    <ResultComponent
      :routes="resultData.routes"
      :nodes="resultData.nodes"
      :total="resultData.total"
      :printData="gpxData"
      @cleanData="cleanData"
      @printPDF="printPDF"
      v-if="result"/>

  </div>

</template>

<script>
import {routesService} from './_services';
import {config} from "./_config";
import {iconHelper, legendHelper} from './_helpers/'
import ResultComponent from './components/ResultComponent'

export default {
  name: 'app',
  components: {
    ResultComponent
  },
  mounted() {
    this.initMap()
    this.getData()
    this.infoLayers()
    //this.getInfoData()
  },
  data() {
    return {
      map: null,
      printer: null,
      control: null,
      routesLayer: null,
      nodesLayer: null,
      routes: {},
      nodes: [],
      start: 0,
      end: 0,
      result: false,
      resultData: {
        routes: [],
        nodes: [],
        total: 0
      },
      baseLayers: {
        raster: null,
        streets: null,
        names: null
      },
      busStops: null,
      busVisible: false,
      trainStations: null,
      overlayMaps: {},
      scale: null,
      defaultRoute: {
        "color": "#ff7800",
        "weight": 5,
        "opacity": 0.65
      },
      accessRoute: {
        "color": "#ff20d4",
        "weight": 5,
        "opacity": 0.65
      },
      selectedStyle: {
        "color": "#ff0000",
        "weight": 8,
        "opacity": 1
      },
      busRoute: {
        "color": "#00ff00",
        "weight": 5,
        "opacity": 0.65
      },
      gpxData: {
        lines: [],
        points: []
      },
      test: null
    }
  },
  computed: {
    validEndNodes() {
      return this.nodes.filter((node) => {
        if (node.value != this.start) return node
      })
    },
    validStartNodes() {
      return this.nodes.filter((node) => {
        if (node.value != this.end) return node
      })
    }
  },
  methods: {
    initMap() {
      this.map = L.map('mapid', {
        preferCanvas: true,
        renderer: L.canvas(),
        maxZoom: 18,
        minZoom: 10
      })

      this.baseLayers.raster = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: 'mapbox.satellite',
        accessToken: config.accessToken
      });
      this.baseLayers.raster.addTo(this.map)

      this.baseLayers.streets = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      })

      this.printer = L.easyPrint({
        tileLayer: this.baseLayers.raster,
        sizeModes: ['Current', 'A4Landscape', 'A4Portrait', {
          width: 1140,
          height: 768,
          className: 'customSize',
          tooltip: 'A custom A3 size'
        }],
        filename: 'mapa',
        hidden: true,
        //exportOnly: true,
        outputMode: 'event',
        hideControlContainer: true
      })
      this.printer.addTo(this.map)

      this.map.on('easyPrint-finished', e => {
        let reader = new FileReader()
        reader.readAsDataURL(e.event)
        reader.onloadend = () => {
          let fd = new FormData()
          fd.append('start', this.gpxData.points[0].name)
          fd.append('sid', this.gpxData.points[0].id)
          fd.append('end', this.gpxData.points.slice(-1)[0].name)
          fd.append('eid', this.gpxData.points.slice(-1)[0].id)
          fd.append('recorrido', JSON.stringify(this.resultData))
          fd.append('ruta', reader.result)
          routesService.getPdf(fd)
            .then(response => {
              document.getElementById('trabajando').classList.remove('visible')
              document.getElementById('trabajando').classList.add('oculto')
              let pdf = document.createElement('a')
              pdf.setAttribute('href', response.data.data.url)
              pdf.setAttribute('target', '_blank')
              pdf.click()
            })
        }
      })

      routesService.getCities().then((data) => {
        this.baseLayers.names = L.geoJSON(data, {
          pointToLayer: (point, latlng) => {
            return L.marker(latlng, {
              zIndexOffset: 1000,
              icon: new L.DivIcon({
                className: 'nucleo',
                html: '<h4>' + point.properties.nombre + '</h4>'
              })
            })
          }
        }).addTo(this.map)
      })

      this.map.on('zoom', this.showStops)
    },
    infoLayers() {
      this.scale = L.control.scale()
      this.scale.addTo(this.map)
      const layers = {
        "Satelite": this.baseLayers.raster,
        "Callejero": this.baseLayers.streets
      }
      this.control = L.control.layers(layers).addTo(this.map)

      this.map.addControl(legendHelper.generateLegend())
    },
    getData() {
      routesService.getAll().then(
        data => {
          this.routesLayer = L.geoJSON(data.routes, {
            style: this.defaultRoute
          });
          this.routesLayer.addTo(this.map);
          this.nodesLayer = L.geoJSON(data.nodes, {
            pointToLayer: (feature, latlng) => {
              return L.marker(latlng, {
                icon: iconHelper.getIcon(feature.poste),
              });
            },
            onEachFeature: (feature, layer) => {
              this.nodes.push({
                'value': feature.id,
                'text': feature.name,
                'poste': feature.poste
              })
              layer.on({
                click: this.clickNode
              })
            }
          })
          this.nodesLayer.addTo(this.map)
          this.map.fitBounds(this.nodesLayer.getBounds()/*, {padding:[5,5]}*/)
        }
      )
    },
    getInfoData() {
      routesService.getAccessPath().then(
        response => {
          if (response.routes.length > 0) {
            const acceso = response.routes.map(route => {
              return L.geoJSON(route).setStyle(this.accessRoute)
            })
            const accesos = L.layerGroup(acceso)
            this.control.addOverlay(accesos, 'ACCESOS')
          }

        }
      )

    },
    showStops() {
      const z = this.map.getZoom()
      /*if (z >= 13)
        this.busStops.addTo(this.map)
      if (z <= 13 && this.busStops)
        this.busStops.remove()

       */
      /*//Mostrar nodos. Tras la fase 2.
      if (z >= 12) {
        this.nodesLayer.addTo(this.map)
        this.baseLayers.names.addTo(this.map)
      }
      if (z < 12) {
        this.nodesLayer.remove()
        this.baseLayers.names.remove()
      }*/
    },
    changeStart() {
      this.cleanNodes()
      this.cleanRoutes()

      this.nodesLayer.getLayers().filter((layer) =>
        layer.feature.geometry.id == this.start
      )[0].setIcon(iconHelper.getIcon(this.start, 'start'))

      if (this.end != 0) {
        this.nodesLayer.getLayers().filter((layer) =>
          layer.feature.geometry.id == this.end
        )[0].setIcon(iconHelper.getIcon(this.end, 'end'))
        this.result = false
        this.searchRoute()
      }
    },
    changeEnd() {
      this.cleanNodes()
      this.cleanRoutes()
      if (this.end != this.start) {
        this.nodesLayer.getLayers().filter((layer) =>
          layer.feature.geometry.id == this.end
        )[0].setIcon(iconHelper.getIcon(this.end, 'end'))
        if (this.start != 0) {
          this.nodesLayer.getLayers().filter((layer) =>
            layer.feature.geometry.id == this.start
          )[0].setIcon(iconHelper.getIcon(this.start, 'start'))
          this.result = false
          this.searchRoute()
        }
      }
    },
    clickNode(event) {
      if (!this.start) {
        this.start = event.target.feature.geometry.id
        event.sourceTarget.setIcon(iconHelper.getIcon(event.target.feature.geometry.poste, 'start'))
      } else {
        if (this.start != event.target.feature.geometry.id) {
          if (this.end != 0) this.clearEnd()
          this.end = event.target.feature.geometry.id
          this.newEnd(event.sourceTarget)
          this.searchRoute()
        }
      }
    },
    clearEnd() {
      this.nodesLayer.getLayers().filter((layer) => {
        return layer.feature.geometry.id == this.end
      })[0].setIcon(iconHelper.getIcon(this.end))
      this.cleanRoutes()
    },
    newEnd(node) {
      
      node.setIcon(iconHelper.getIcon(node.feature.geometry.poste, 'end'))
      if (this.result) this.result = false
    },
    searchRoute() {
      routesService.search(this.start, this.end).then((response) => {
        this.resultData.routes = response.data.data.routes;
        this.resultData.nodes = response.data.data.nodes;
        this.resultData.total = response.data.data.total;
        this.result = true
        this.drawResultRoutes()
      })
    },
    drawResultRoutes() {
      let bounds = [];
      this.gpxData.lines = []
      this.gpxData.points = []
      this.resultData.routes.forEach((route) => {
        this.routesLayer.getLayers().forEach((e) => {
          if (route.edge == e.feature.geometry.id) {
            e.setStyle(this.selectedStyle)
            bounds.push(e.getBounds(), {padding: [15, 15]})
            const li = {name: e.feature.geometry.name, coords: []}
            e.getLatLngs().forEach((c) => {
              li.coords.push({lat: c.lat, lon: c.lng})
            })
            this.gpxData.lines.push(li)
          }
        })
      })

      this.resultData.nodes.forEach((node) => {
        this.nodesLayer.getLayers().forEach((n) => {
          if (node.id == n.feature.geometry.id) {
            const no = {
              name: node.nombre,
              id: node.id,
              coords: {
                lat: n.getLatLng().lat,
                lon: n.getLatLng().lng
              }
            }
            this.gpxData.points.push(no)
          }
        })
      })
      this.map.fitBounds(bounds)
    },
    cleanData() {
      this.start = 0;
      this.end = 0;
      this.result = false;
      this.cleanRoutes()
      this.cleanNodes()
      this.map.fitBounds(this.nodesLayer.getBounds()/*, {padding:[5,5]}*/)
    },
    cleanRoutes() {
      this.routesLayer.getLayers().forEach((e) => {
        e.setStyle(this.defaultRoute)
      })
    },
    cleanNodes() {
      this.nodesLayer.getLayers().forEach((e) => {
        e.setIcon(iconHelper.getIcon(e.feature.geometry.id))
      })
    },
    printPDF() {
      const sid = this.resultData.nodes[0].id
      const start = this.resultData.nodes[0].nombre
      const eid = this.resultData.nodes.slice(-1)[0].id
      const end = this.resultData.nodes.slice(-1)[0].nombre
      const name = 'Ruta_' + start + '_' + end
      document.getElementById('trabajando').classList.remove('oculto')
      document.getElementById('trabajando').classList.add('visible')
      routesService.checkPdf(sid, eid, start, end)
        .then(response => {
          if (response.data.result) {
            window.open(encodeURI(response.data.url))
          } else {
            this.printer.printMap('customSize', name)
          }
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue